import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                Sugargoo <span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your ultimate resource hub for Sugargoo product finds, shipping guides, honest reviews, and exclusive coupons. Helping shoppers discover the best deals since 2024.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Complete Spreadsheet Guide</Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Shop Products</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Shoes</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Hoodies &amp; Sweaters</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">T-Shirts</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Jackets</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">SEO Guides</h4>
            <ul className="space-y-2.5">
              {articles.slice(0, 5).map((article) => (
                <li key={article.slug}>
                  <Link to={`/` + article.slug} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors line-clamp-1">
                    {article.title.length > 40 ? article.title.slice(0, 40) + '...' : article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 Sugargoo Spreadsheet Hub. All rights reserved. This is an independent informational website.
          </p>
          <p className="text-xs text-foreground-500">
            Built with care for the Sugargoo community.
          </p>
        </div>
      </div>
    </footer>
  );
}